import { useDispatch, useSelector } from "react-redux";
import ItemList from "./ItemList";
import { clearCart } from "../utils/cardSlice";

const Cart = () => {

     const cartItems = useSelector((store) => store.cart.items);

     const dispatch = useDispatch();
     const handleClearCart =()=>{
          dispatch(clearCart());
     };

     return (
          <div className="text-center m-4 p-4">
               <h1 className="text-3xl font-extrabold m-6">Cart</h1>
               <h1 className="m-4 p-4 font-bold text-xl">Total Items added : {cartItems.length} </h1>
               <div>
                    <button className="p-2 m-4 bg-black text-white rounded-lg" 
                    onClick={handleClearCart}>Clear Cart</button>
                    {cartItems.length === 0 && <h1>Cart is empty!! Add items to the cart</h1>}
                    <ItemList items={cartItems}/>
               </div>
          </div>
     );
};

export default Cart;